export default __webpack_public_path__ + "images/8617eac7db7c41e6a7efca87af8e441c.svg";